import React from 'react';
import { IBlockDesc, IBlockDescriptionItem, ISymbolOrderItem } from './Paytable.types';

export function multiplierCompare(a: ISymbolOrderItem, b: ISymbolOrderItem) {
    if (a.multiplier < b.multiplier) {
        return -1;
    }
    if (a.multiplier > b.multiplier) {
        return 1;
    }
    return 0;
}

export function customOrder(currentOrder: ISymbolOrderItem[], orderArray: number[]) {
    const customOrder: Array<ISymbolOrderItem> = [];
    orderArray.forEach((id) => {
        currentOrder.forEach((symbol) => {
            if (symbol.id === id) customOrder.push(symbol);
        });
    });

    return customOrder;
}

export function getBlockDescription(data: IBlockDesc, getPayLineValue: Function) {
    let element: IBlockDescriptionItem[] = [];
    let raw = '';

    if (data.paylines?.length) {
        data.paylines.forEach((item, index) => {
            const counts = [...item.count].reverse();
            const multiplier = [...item.multiplier].reverse();
            counts.forEach((val, index) => {
                const line = `${val}x ${getPayLineValue(multiplier[index], data.isRolesPaytable)}`;
                raw += line;
                element.push({ lineNumber: index, lineLength: line.length, lineString: line });
            });
        });
    }

    return {
        dom: element,
        raw: raw
    };
}
